import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export interface ExternalIntegrationDto {
  clientId: string;
  name?: string;
}

const useGetExternalIntegrations = (options?: QueryOptions<ExternalIntegrationDto[]>) => {
  const business = useSelectedBusiness();
  return useUserQuery<ExternalIntegrationDto[]>(
    { path: `/api/businesses/${business.id}/externalIntegrations` }, options);
}

export default useGetExternalIntegrations;
